import axios from 'axios';
import SessionStorage from '../utils/session-storage';
import { GEOLOCATION_DATA_KEY } from '../utils/session-storage-keys';

export default class GeolocationAPI {
  constructor() {
    this.baseURL = process.env.IP_GEOLOCATION_BASE_URL;
    this.apiKey = process.env.IP_GEOLOCATION_API_KEY;
  }

  detectCurrentLocation = () => {
    try {
      return axios.get(`${this.baseURL}?apiKey=${this.apiKey}`).then((response) => {
        const { data } = response;

        return {
          countryCode: data.country_code2,
          countryName: data.country_name,
          currency: data.currency,
          city: data.city,
          isEU: data.is_eu,
          zipCode: data.zipcode,
          isDomestic: data.country_code2 === 'US',
          countryFlag: data.country_flag
        };
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      return console.error(error);
    }
  };

  saveCurrentLocation = () => {
    try {
      return this.detectCurrentLocation().then((data) => SessionStorage.set(GEOLOCATION_DATA_KEY, data));
    } catch (error) {
      // eslint-disable-next-line no-console
      return console.error(error);
    }
  };
}
